import { CaseLower, CaseSensitive, CaseUpper } from 'lucide-react';
import { BiHighlight } from 'react-icons/bi';
import { GrTextAlignLeft, GrTextAlignCenter, GrTextAlignRight, GrTextAlignFull } from 'react-icons/gr';
import { RiItalic, RiUnderline, RiStrikethrough, RiFontColor, RiListOrdered, RiListUnordered } from 'react-icons/ri';

import FontSizeFormatter from '../components/FontSizeFormatter';
import FormatterIcon from '../components/FormatterIcon';
import HeadingFormatter from '../components/Heading';
import LetterSpacingFormatter from '../components/LetterSpacing';
import TableFormatters from '../components/TableFormatters';
import FontWeightFormatter from '../components/fontWeight';

import NewColorFormatter from './components/ColorFormatter';

export const bubbleFormatters = {
  titleFormatters: editor => {
    if (!editor) return;
    return (
      <>
        <FontSizeFormatter value={editor.getTailwindValue({ name: 'fontSize' })?.value} style={{ width: 'max-content' }} editor={editor} id="tooltip-fontsize" tooltipText="Font size" />
        <LetterSpacingFormatter value={editor.getTailwindValue({ name: 'letterSpacing' })?.value} editor={editor} tooltipText="letter spacing" />
        <HeadingFormatter editor={editor} tooltipText="heading" />
      </>
    )
  },
  alignFormatters: editor => {
    if (!editor) return;
    return (
      <>
        <FormatterIcon active={editor.getTailwindValue({ name: 'textAlign', value: 'left', extensionName: 'paragraph' })} icon={GrTextAlignLeft} onClick={() => editor.chain().focus().setTextAlign('left').run()} id="tooltip-align-left" tooltipText="align left" />
        <FormatterIcon active={editor.getTailwindValue({ name: 'textAlign', value: 'center', extensionName: 'paragraph' })} icon={GrTextAlignCenter} onClick={() => editor.chain().focus().setTextAlign('center').run()} id="tooltip-align-center" tooltipText="align center" />
        <FormatterIcon active={editor.getTailwindValue({ name: 'textAlign', value: 'right', extensionName: 'paragraph' })} icon={GrTextAlignRight} onClick={() => editor.chain().focus().setTextAlign('right').run()} id="tooltip-align-right" tooltipText="align right" />
        <FormatterIcon active={editor.getTailwindValue({ name: 'textAlign', value: 'justify', extensionName: 'paragraph' })} icon={GrTextAlignFull} onClick={() => editor.chain().focus().setTextAlign('justify').run()} id="tooltip-align-justify" tooltipText="align justify" />
      </>
    )
  },
  colorFormatters: editor => {
    if (!editor) return;
    return (
      <>
        <NewColorFormatter value={editor.getTailwindValue({ name: 'textColor' })} onClick={color => editor.chain().focus().setTextColor(color).run()} onReset={() => editor.chain().focus().unsetColor().run()} icon={RiFontColor} id="tooltip-color" tooltipText="font color" />
        <NewColorFormatter value={editor.getTailwindValue({ name: 'backgroundColor' })} onClick={color => editor.chain().focus().setBackgroundColor(color).run()} onReset={() => editor.chain().focus().unsetHighlight().run()} icon={BiHighlight} id="tooltip-highlith" tooltipText="background" />
      </>
    )
  },
  markFormatters: editor => {
    if (!editor) return;

    return (
      <>
        <FontWeightFormatter value={editor.getTailwindValue({ name: 'fontWeight' })?.value} style={{ width: 'max-content' }} editor={editor} id="tooltip-fontweight" tooltipText="Font weight" />
        <FormatterIcon active={editor.getTailwindValue({ name: 'fontStyle', value: 'italic' })} icon={RiItalic} onClick={() => editor.chain().focus().toggleItalic().run()} id="tooltip-italic" tooltipText="italic" />
        <FormatterIcon active={editor.getTailwindValue({ name: 'textDecoration', value: 'underline' })} icon={RiUnderline} onClick={() => editor.chain().focus().toggleUnderline().run()} id="tooltip-underline" tooltipText="underline" />
        <FormatterIcon active={editor.getTailwindValue({ name: 'textDecoration', value: 'line-through' })} icon={RiStrikethrough} onClick={() => editor.chain().focus().toggleStrike().run()} id="tooltip-strike" tooltipText="strike" />
        <FormatterIcon active={editor.getTailwindValue({ name: 'textTransform', value: 'uppercase' })} icon={CaseUpper} onClick={() => editor.chain().focus().setUppercase().run()} id="tooltip-uppercase" tooltipText="upper case" />
        <FormatterIcon active={editor.getTailwindValue({ name: 'textTransform', value: 'lowercase' })} icon={CaseLower} onClick={() => editor.chain().focus().setLowercase().run()} id="tooltip-uppercase" tooltipText="lower case" />
        <FormatterIcon active={editor.getTailwindValue({ name: 'textTransform', value: 'capitalize' })} icon={CaseSensitive} onClick={() => editor.chain().focus().setCapitalize().run()} id="tooltip-uppercase" tooltipText="capitalize" />
      </>
    )
  },
  tableFormatters: editor => {
    if (!editor) return;
    return (
      <>
        <TableFormatters editor={editor} tooltipText="add table" />
      </>
    )
  },
  listFormatters: editor => {
    if (!editor) return;

    return (
      <>
        <FormatterIcon active={editor.isActive('bulletList')} icon={RiListOrdered} onClick={() => editor.chain().focus().toggleOrderedList(editor.isActive('bulletList')).run()} tooltipText="ordered list" />
        <FormatterIcon active={editor.isActive('orderedList')} icon={RiListUnordered} onClick={() => editor.chain().focus().toggleBulletList(editor.isActive('orderedList')).run()} tooltipText="bullet list" />
      </>
    )
  },
}
